import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function getGroupById(groupId) {
    try {
        const data = await axios.get(`${REACT_APP_API}/groups/${groupId}`)
        const group = data?.data
        if (!data) throw new Error('No se encontró el Grupo')
        return group
    } catch (error) {
        throw new Error(error)
    }
}